const accounts = {
    title: "{professional} account selection",
    tab: "Account selection"
}

export default accounts;